import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'


const AuthmiddlewareHerd = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  isAuth,
  isHerdRoutes,
  PremierData,
  premierUserLoading,
  isHerdUser,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isHerdRoutes && !isHerdUser) {
        return (
          <Redirect
            to={{ pathname: '/events', state: { from: props.location } }}
          />
        )
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AuthmiddlewareHerd.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default AuthmiddlewareHerd